/**
 * Lesehilfen für fremdes JSON.
 *
 * Alles, was von aussen kommt - eine Importdatei, ein Dokument aus dem Abgleich,
 * ein Bestand aus einer älteren Fassung der App - ist unknown und darf nicht
 * geglaubt werden. Diese vier Funktionen sind die einzige Stelle, an der die
 * Annahmen darüber stehen: fehlende und kaputte Felder werden zu einem
 * brauchbaren Ersatzwert, statt die ganze Datei zu verlieren.
 *
 * Sie liegen für sich, weil sowohl transfer.ts (Datei) als auch checks.ts
 * (Dokument) sie brauchen und zwei Fassungen derselben Prüfung mit der Zeit
 * auseinanderlaufen.
 */

/** Wahr für ein Objekt mit Feldern - nicht für null und nicht für ein Array. */
export function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v)
}

/** Was keine Liste ist, wird zur leeren Liste. */
export function asArray(v: unknown): unknown[] {
  return Array.isArray(v) ? v : []
}

/**
 * Die Liste, oder null wenn es keine ist.
 *
 * Der Unterschied zu asArray: hier lässt sich "leere Liste" von "keine Liste"
 * unterscheiden. Genau daran hängt beim Lesen der Checklisten die Entscheidung,
 * ob ein Feld im neuen Format vorliegt und der Nutzer alles entfernt hat, oder
 * ob es fehlt und die Startbestückung greifen muss.
 */
export function asList(v: unknown): unknown[] | null {
  return Array.isArray(v) ? (v as unknown[]) : null
}

/** Text, oder eine Zahl als Text. Alles andere wird zur leeren Zeichenkette. */
export function str(v: unknown): string {
  return typeof v === 'string' ? v : typeof v === 'number' ? String(v) : ''
}

/** Zahl, notfalls aus einem Text. Was keine ergibt, wird zum Ersatzwert. */
export function num(v: unknown, fallback: number): number {
  const n = typeof v === 'number' ? v : Number(v)
  return Number.isFinite(n) ? n : fallback
}
